export function getDefaultItemStyles() {
  return {
    padding: true,
    showBackground: true,
  };
}
